//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import {Link} from 'react-router-dom'
//@end

//@import config
import {has_site} from 'app_config/globals'
//@end

//@import service
import {routingService} from 'app_services/routingService'
//@end

// @INFO Import Styles
import './../headerAuthCommon.scss'

// @ADD Component types
interface IHeaderAuthCommonLayoutProps {}

const HeaderAuthCommonLayout: React.FC<IHeaderAuthCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <nav className='navbar navbar-expand-lg navbar-light bg-light'>
      <Link className='navbar-brand' to={routingService.getSecurePath()}>Navbar</Link>
      <button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent' aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
        <span className='navbar-toggler-icon'></span>
      </button>

      <div className='collapse navbar-collapse' id='navbarSupportedContent'>
        <ul className='navbar-nav mr-auto'>
          <li className='nav-item'>
            <Link className='nav-link' to={routingService.getPublicPath('/login')}>{t('sandbox.nav.login')}</Link>
          </li>
          <li className='nav-item'>
            <Link className='nav-link' to={routingService.getPublicPath('/register')}>{t('sandbox.nav.register')}</Link>
          </li>
        </ul>
        <ul className='navbar-nav my-2 my-lg-0'>
          {has_site && (
            <li className='nav-item'>
              <Link className='nav-link' to={routingService.getPublicPath()}>{t('sandbox.nav.site')}</Link>
            </li>
          )}
        </ul>
      </div>
    </nav>
  )
}

export default HeaderAuthCommonLayout

